import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { View } from '@shared/components/View';
import { CardFormContext } from '@shared/components/blocks/contexts/form';
import { MBIconV2 } from '@shared/components/image';
import { MBTextBody2 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

export function FormErrorBanner() {
  const colors = useContext(ColorThemeContext);
  const { errors } = useContext(CardFormContext);
  const hasErrors = !isEmpty(errors);

  if (!hasErrors) {
    return null;
  }

  return (
    <View row centerVertically paddingHorizontal={3} paddingVertical={1}>
      <MBIconV2 name="exclamation-filled" size={grid(3)} color={colors.error.foreground} />
      <View flex paddingLeft={1}>
        <MBTextBody2 color={colors.error.foreground}>{i18n('card.form.errorBanner')}</MBTextBody2>
      </View>
    </View>
  );
}
